import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" API tokens can be used to access your organization's player data and queue tasks, you can learn more "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "anchor--primary",
    href: "https://docs.steamcord.io"
  }, "here"),
  /*#__PURE__*/_createTextVNode(". In order to use a Steamcord integration, e.g.Steamcord "),
  /*#__PURE__*/_createElementVNode("span", { class: "rust" }, "Rust"),
  /*#__PURE__*/_createTextVNode(" or Steamcord "),
  /*#__PURE__*/_createElementVNode("span", { class: "gmod" }, "Garry's Mod"),
  /*#__PURE__*/_createTextVNode(", you must generate an API token. ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " For security reasons, you cannot view your API token after it is initially created; therefore be sure to give your token a descriptive name. ", -1)
const _hoisted_3 = { class: "dashboard__section" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Create an API Token", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Create token ")
const _hoisted_6 = { class: "code-block" }
const _hoisted_7 = { class: "code-block__content" }
const _hoisted_8 = { class: "dashboard__section" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Your API Tokens", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "api-tokens__tokens"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_token = _resolveComponent("token")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("form", {
        class: "input-button-group",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createToken && _ctx.createToken(...args)), ["prevent"]))
      }, [
        _createVNode(_component_base_input, {
          class: "input-button-group__input",
          placeholder: "Token name, e.g. my gmod server",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue"]),
        _createVNode(_component_loading_button, {
          class: "input-button-group__button",
          "button-type": "button--inverted",
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32),
      _withDirectives(_createElementVNode("span", { class: "api-tokens__error form__error" }, _toDisplayString(_ctx.nameError), 513), [
        [_vShow, _ctx.nameError]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.createdToken), 1),
        _createElementVNode("button", {
          class: "code-block__copy button--primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyCreatedToken && _ctx.copyCreatedToken(...args)))
        }, [
          (_ctx.copySuccess)
            ? (_openBlock(), _createBlock(_component_fa_icon, {
                key: 0,
                icon: ['far', 'check']
              }))
            : (_openBlock(), _createBlock(_component_fa_icon, {
                key: 1,
                icon: ['far', 'copy']
              }))
        ])
      ], 512), [
        [_vShow, _ctx.createdToken]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      (_ctx.tokens.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Once you create API tokens, you will see them here. "))
        : (_openBlock(), _createElementBlock("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
              return (_openBlock(), _createBlock(_component_token, {
                id: token.id,
                key: token.id,
                name: token.name,
                createdDate: token.createdDate,
                onRevoked: _ctx.revokeToken
              }, null, 8, ["id", "name", "createdDate", "onRevoked"]))
            }), 128))
          ]))
    ])
  ]))
}